import React from 'react';

import { Type } from '@spotify-internal/encore-creator-web';
// import { gray50 } from '@spotify-internal/encore-foundation';

import { VSpacer20 } from '../../../Elements';
import { faqUrl } from '../../lib/constants';
import { DialogBodyProps } from '../../types';
import { DialogWrapper } from '../DialogWrapper';
import {
  Heading3FontSize16,
  PFontSize16,
  TextLinkUnderlined,
} from '../StyleElements';

// eslint-disable-next-line
export function FormSuccess(_p: DialogBodyProps) {
  return (
    <DialogWrapper
      style={{
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: '584px',
        minHeight: '100%',
      }}
    >
      <Type as="h2" variant={Type.heading2}>
        Your fundraising link has been received
      </Type>
      <VSpacer20 />
      <Heading3FontSize16>Here's what happens next:</Heading3FontSize16>
      <PFontSize16>
        Most Artist Fundraising Picks will be posted immediately. In some cases,
        links may be manually reviewed, which may take a bit longer. After your
        link is approved, fans can find it at the top of your artist profile on
        Spotify.
      </PFontSize16>

      <PFontSize16>
        For general questions about how COVID-19 support works, see our{' '}
        <TextLinkUnderlined href={faqUrl} target="faq">
          FAQ
        </TextLinkUnderlined>
        .
      </PFontSize16>
    </DialogWrapper>
  );
}
